<div nz-row [nzJustify]="'center'">
    @if (isLoading) {
    <nz-skeleton [nzActive]="true"></nz-skeleton>
    } @else if (quote) {
    <div nz-col [nzSpan]="20">
        <div>
            <button nz-button nzType="default" (click)="onClickBackToIncident()" [nzSize]="'large'"><nz-icon nzType="arrow-left" nzTheme="outline" /> Back to Breakdown</button>
        </div>
        <app-quote-header [quote]="quote"></app-quote-header>
        <nz-divider></nz-divider>
        @if (quote.basedOnQuoteId && !isReadOnly) {
            <div style="text-align: center;">
                <a nz-dropdown [nzDropdownMenu]="priceTemplateList">Preview price template change<nz-icon nzType="down" /></a>
            </div>
            <nz-dropdown-menu #priceTemplateList="nzDropdownMenu">
                <ul nz-menu>
                    @for (item of pricingTemplates; track $index) {
                    <li nz-menu-item (click)="onClickPreviewPriceTemplateChanges(item.pricingTemplateId)">{{ item.pricingName }}</li>
                    }
                </ul>
            </nz-dropdown-menu>
        }
        
            @if (invoiceUrl) {
                <div nz-row [nzJustify]="'space-between'" style="margin-bottom: 20px;">
                    <div nz-col nzSpan="12">
                        <app-quote-details [quote]="quote" [isLoadingLines]="isLoadingLines" [isReadOnly]="isReadOnly" [canSelectOptions]="canSelectOptions" (saveQuote)="saveQuote()"></app-quote-details>
                    </div>         
                    <div nz-col nzSpan="11">            
                        <app-pdf-viewer [pdfUrl]="invoiceUrl"></app-pdf-viewer>
                    </div> 
                </div>
             } @else {
                <app-quote-details [quote]="quote" [isLoadingLines]="isLoadingLines" [isReadOnly]="isReadOnly" [canSelectOptions]="canSelectOptions" (saveQuote)="saveQuote()"></app-quote-details>
             }       

        

        <div nz-row [nzJustify]="'space-between'">
            @if (!isReadOnly) {
            <button nz-button nzType="primary" (click)="saveQuote()" [nzLoading]="isSaving" [nzSize]="'large'"><nz-icon nzType="save" nzTheme="outline" /> Update Quote</button>
            }
            @if (!isReadOnly && quote.statusId === 1 && this.quote.incidentStatusId === 11) {
            <button nz-button nzType="primary" (click)="onClickUploadSPInvoice()" [nzLoading]="isSaving" [nzSize]="'large'"><nz-icon nzType="upload" nzTheme="outline" /> Upload Service Provider Invoice</button>
            }
            @if (!isReadOnly && quote.statusId === 1 && this.quote.sellerId !== this.authService.user?.clientId && this.quote.incidentStatusId === 12) {
            <button nz-button nzType="primary" (click)="convertToJobCard()" [nzLoading]="isSaving" [nzSize]="'large'" [disabled]="this.quote.quoteOptions.length !== 1"><nz-icon nzType="shopping-cart" nzTheme="outline" /> Convert to PO</button>
            <button nz-button nzType="primary" (click)="toggleSPInvoice()" [nzSize]="'large'">{{ invoiceUrl ? 'Close SP Invoice': 'Open SP Invoice'}}</button>
            }
            @if (!isReadOnly && this.quote.sellerId === this.authService.user?.clientId) {
            <button nz-button nzType="primary" (click)="convertToInvoice()" [nzLoading]="isSaving" [nzSize]="'large'" [disabled]="this.quote.quoteOptions.length !== 1"><nz-icon nzType="shopping-cart" nzTheme="outline" /> Convert to Invoice</button>
            }
            <button nz-button nzType="primary" (click)="onClickQuotePDF(quote.quoteId)" [nzLoading]="isSaving" [nzSize]="'large'"><nz-icon nzType="download" nzTheme="outline" />Download Quote</button>
            @if (isReadOnly && quote.statusId === 11) {
            <button nz-button nzType="primary" (click)="viewInvoice()" [nzLoading]="isSaving" [nzSize]="'large'"><nz-icon nzType="eye" nzTheme="outline" />View Invoice</button>
            }
        </div>
        
    </div>
    } @else {
    <div nz-col [nzSpan]="20">
        <nz-alert nzType="error" nzMessage="Failed to load quote details." nzShowIcon></nz-alert>
    </div>
    }
</div>


<nz-modal [(nzVisible)]="isUploadModalVisible" nzTitle="Upload File" (nzOnCancel)="isUploadModalVisible = false"
  (nzOnOk)="onUploadOK()">
  <ng-container *nzModalContent>
    <app-file-uploader [incidentId]="quote.incidentId"
      (uploadedDocuments)="onUploadComplete($event)" [documentClassification]="4"></app-file-uploader>
  </ng-container>
</nz-modal>